import { render, staticRenderFns } from "./CallInfo.vue?vue&type=template&id=4e5db7b8&scoped=true"
import script from "./CallInfo.vue?vue&type=script&lang=js"
export * from "./CallInfo.vue?vue&type=script&lang=js"
import style0 from "./CallInfo.vue?vue&type=style&index=0&id=4e5db7b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5db7b8",
  null
  
)

export default component.exports